import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';
import router from './router'
import store from './store'
import quasarUserOptions from './quasar-user-options'

createApp(App).use(router).use(store).use(Quasar, { plugins: { Loading, Notify } }, quasarUserOptions).mount('#app')
